// Shared vocabulary for current data, dashboard and newly generated reports.
// external is retained only for persisted decisions and frozen reports.
export const SERP_CLASSIFICATION_LABELS = {
  owned: 'Наш ресурс',
  donor: 'Донор',
  competitor: 'Конкурент',
  fake: 'Подражатель / фейк',
  about: 'О нас',
  namesake: 'Совпадение названия',
  unrelated: 'Посторонний результат',
  unreviewed: 'Не разобрано',
  unknown: 'Неизвестно',
  conflict: 'Конфликт решения',
  external: 'Сторонний ресурс (прежнее решение)',
} as const;
export type FakeClassification = keyof typeof SERP_CLASSIFICATION_LABELS;
export const SERP_CLASSIFICATIONS = Object.keys(SERP_CLASSIFICATION_LABELS) as FakeClassification[];
export const CURRENT_CLASSIFICATIONS = SERP_CLASSIFICATIONS.filter((key) => key !== 'external');
export const FAKE_VERDICTS = [
  'fake',
  'about',
  'namesake',
  'unrelated',
  'unreviewed',
  'external',
] as const;
export type FakeVerdict = (typeof FAKE_VERDICTS)[number];
export const MENTION_LABELS = {
  positive: 'Позитивный',
  neutral: 'Нейтральный',
  negative: 'Негативный',
  mixed: 'Смешанный',
  unclear: 'Неясный',
} as const;
export type MentionSentiment = keyof typeof MENTION_LABELS;
export const MENTION_SENTIMENTS = Object.keys(MENTION_LABELS) as MentionSentiment[];
export function emptyClassificationCounts(): Record<FakeClassification, number> {
  return Object.fromEntries(SERP_CLASSIFICATIONS.map((key) => [key, 0])) as Record<
    FakeClassification,
    number
  >;
}
